import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const emmdepartmentApi = createApi({
  reducerPath: 'emmdepartmentApi',
  baseQuery: btBaseQuery,
  tagTypes: ['Department'],

  endpoints: (builder) => ({
    getDepartments: builder.query<em_mdepartment[], string>({
      query: (cid) => `emdepartment/${cid}`,
      providesTags: ['Department']
    }),
    getDepartment: builder.query<em_mdepartment, string>({
      query: (id) => `emdepartment/byid/${id}`
    }),
    insertDepartment: builder.mutation({
      query: (emdepartment) => ({
        url: `emdepartment/`,
        method: 'POST',
        body: emdepartment
      }),
      invalidatesTags: ['Department']
    }),
    updateDepartment: builder.mutation({
      query: (emdepartment) => ({
        url: `emdepartment/`,
        method: 'PUT',
        body: emdepartment
      }),
      invalidatesTags: ['Department']
    }),
    deleteDepartment: builder.mutation({
      query: (emdepartment) => ({
        url: `emdepartment/${emdepartment.dp_id}`,
        method: 'DELETE',
        body: emdepartment
      }),
      invalidatesTags: ['Department']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDepartmentsQuery,
  useGetDepartmentQuery,
  useInsertDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation
} = emmdepartmentApi;
